var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import isFinite from "lodash-es/isFinite.js";
Number.prototype.correctFloat = function(prec) {
  return this.valueOf() > 1e14 ? this.valueOf() : parseFloat(this.toPrecision(prec || 14));
};
Number.prototype.applyRatio = function(ratio) {
  return this.valueOf() + this.valueOf() * ratio;
};
Number.prototype.formatEx = function(options) {
  if (isNaN(this.valueOf())) {
    return "NaN";
  }
  if (this.valueOf() === Infinity) {
    return "Infinity";
  }
  if (this.valueOf() === -Infinity) {
    return "-Infinity";
  }
  const key = JSON.stringify(options);
  if (!cache.get(key)) {
    cache.set(key, Intl.NumberFormat(void 0, options));
  }
  return cache.get(key).format(this.valueOf());
};
function getAutoFractionDigits(value) {
  const maximumFractionDigits = value < 1 ? 7 : value < 10 ? 6 : value < 100 ? 5 : value < 1e3 ? 4 : value < 1e4 ? 3 : 2;
  return maximumFractionDigits;
}
__name(getAutoFractionDigits, "getAutoFractionDigits");
function formatNumber(data, maximumFractionDigits = "auto", useGrouping = true, signDisplay = "auto") {
  const newMaxFraction = maximumFractionDigits === "auto" ? getAutoFractionDigits(data) : maximumFractionDigits;
  const newSignDisplay = signDisplay === true ? "always" : signDisplay === false ? "auto" : signDisplay;
  return data.formatEx({ maximumFractionDigits: newMaxFraction, useGrouping, signDisplay: newSignDisplay });
}
__name(formatNumber, "formatNumber");
Number.prototype.format = function(maximumFractionDigits = "auto", useGrouping = true, signDisplay = "auto") {
  return formatNumber(this.valueOf(), maximumFractionDigits, useGrouping, signDisplay);
};
Number.prototype.formatFixed = function(fractionDigits, useGrouping = true, signDisplay = "auto") {
  return this.formatEx({
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
    useGrouping,
    signDisplay: signDisplay === true ? "always" : signDisplay === false ? "auto" : signDisplay
  });
};
BigInt.prototype.toJSON = function() {
  return Number(this);
};
function isValidNumber(value) {
  return typeof value === "number" && isFinite(value);
}
__name(isValidNumber, "isValidNumber");
function isOverlappedOrAdjacent(rangeA, rangeB, includeAdjacent = false) {
  const [aStart, aEnd] = rangeA;
  const [bStart, bEnd] = rangeB;
  if (includeAdjacent) {
    return Math.max(aStart, bStart) <= Math.min(aEnd, bEnd);
  }
  return Math.max(aStart, bStart) < Math.min(aEnd, bEnd);
}
__name(isOverlappedOrAdjacent, "isOverlappedOrAdjacent");
export {
  formatNumber,
  isOverlappedOrAdjacent,
  isValidNumber
};
//# sourceMappingURL=number.js.map
